import React from 'react';
import { palette } from '../../styles/theme';

export function VectorMenuSVG ({ open = false, customStroke = palette.secondary.main }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" transform={open ? 'rotate(180)' : 'rotate(0)'} height="24" viewBox="0 0 24 24" fill="none">
            <g clipPath="url(#clip0_6172_11899)">
                <path d="M6 9L12 15L18 9" stroke={customStroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_6172_11899">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
